const merge = require('lodash/merge');
const parseRequestMetaData = require('../../utils/parse-request-meta-data');
const apiConfig = require('../../api-config');
const base64 = require('base-64');

function apiFactory({
  baseUrl,
  requestHandler
}) {
  const headers = {
    Accept: 'application/json'
  };

  function getUrl(endpoint) {
    return `${baseUrl}${endpoint}`;
  }

  return {
    getUserNotifications(roleId, lastLoginValue,  metaData) {
      const url = getUrl('get-user-notifications');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        roleId: roleId.split(','),
        lastLoginSession: lastLoginValue,
        language: parsedMetaData.portfolio.language,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    getUserNotificationsCombine(roleId, lastLoginValue, langCode, metaData) {
      const url = getUrl('get-user-notifications');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };
      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,
        roleId: roleId.split(','),
        lastLoginSession: lastLoginValue,
        language: langCode,
      };
      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    setAsReadUserNotifications(metaData) {
      const url = getUrl('set-as-read-user-notifications');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    getUserPrefNotifications(metaData) {
      const url = getUrl('get-user-pref-notifications');
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: apiConfig.branchCode,

      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },

    saveUserPrefNotifications(encAlertTypes, metaData) {
      const url = getUrl('save-user-pref-notifications');
      const alertTypes = JSON.parse(base64.decode(encAlertTypes));
      const parsedMetaData = parseRequestMetaData(metaData);
      const reqOpts = {
        headers: merge(headers, parsedMetaData.headers),
        method: 'POST'
      };

      const body = {
        userId: parsedMetaData.qs.userId,
        branchCode: parsedMetaData.portfolio.branchCode,
        alertTypes,
      };

      return requestHandler(merge(reqOpts, {
        url,
        body,
        json: true,
      }));
    },
  };
}

module.exports = apiFactory;
